'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const Key = require('common/domain/value/key');
const TimelineListView = require('balus/ui/view/timeline/list');
const CommentCreateService = require('communication/app/service/comment/create');
const TaskReplyCommentService = require('communication/app/service/task/reply-comment');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');
const CommentView = require('./comment');
const Template = require('balus/ui/template/timeline/index.hbs');

class TimelineView extends Mn.View {
    constructor(options) {
        super(options);

        this._isSending = false;
    }

    get template() {
        return Template;
    }

    get className() {
        return 'timeline';
    }

    regions() {
        return {
            list: '.timeline-list',
            comment: '.timeline-comment-wrapper',
        };
    }

    childViewEvents() {
        return {
            'focus': 'openComment',
            'close': 'closeComment',
            'comment:sent': 'onComment',
            'comment:task:sent': 'onCommentTask',
            'comment:sent:draft': 'onCommentSentDraft',
            'reply': 'onReply',
            'select:member': 'onSelectedMembers',
            'comment:form:resized': 'autoScrollToFocus',
            'showJumpToRecentMessage': 'showJumpToRecentMessage',
            'hideJumpToRecentMessage': 'hideJumpToRecentMessage',
            'add:content': 'addContent'
        };
    }

    events() {
        return {
            'click > .timeline-jump-to-recent-message a.jump-to-recent-message': 'jumpToRecentMessage'
        };
    }

    onRender() {
        this.showChildView('list', new TimelineListView({
            collection: this.getOption('collection'),
            context: this.getOption('context'),
            channel: this.getOption('channel')
        }));

        const context = this.getOption('context');
        const user = context.getUser();
        const group = context.getGroup();
        const draftComment = CommentCollectionRepository.getDraft(this.model);

        if(group.isMember(user ? user.id : null)) {
            this.showChildView('comment', new CommentView({
                rows: 1,
                hideEditorTab: 1,
                context: this.getOption('context'),
                draftComment: draftComment
            }));
        }
    }

    onComment(comment) {
        if(!this._isSending) {
            this.getChildView('comment').commentDisabled();
            const context = this.getOption('context');
            const project = context.getProject();

            comment.relatedKeys.unshift(context.get().key);
            comment.relatedKeys = _.map(comment.relatedKeys, key => key.toString());
            comment.relatedKeys = _.filter(comment.relatedKeys, str => str);

            (new CommentCreateService(project, comment))
                .execute()
                .then(() => {
                    this.closeComment();
                    this.getChildView('comment').removeReplyTo();
                    this.getChildView('comment').cleanup();
                    this.getChildView('comment').commentEnabled();
                    CommentCollectionRepository.clearDraft(this.model);
                    this._isSending = false;
                    this.trigger('comment:sent');
                })
                .catch(() => {
                    this.getChildView('comment').commentEnabled();
                    this._isSending = false;
                });
            this._isSending = true;
        }
    }

    onCommentTask(comment, task) {
        this.getChildView('comment').commentDisabled();
        const project = this.getOption('context').getProject();
        comment.relatedKeys = _.union([task.getPrimaryRelatedKey()], comment.relatedKeys);
        comment.relatedKeys = _.map(comment.relatedKeys, key => key.toString());

        const taskService = new TaskReplyCommentService(project, task.id, comment);
        taskService.replyComment()
            .then(() => {
                this.closeComment();
                this.getChildView('comment').removeReplyTo();
                this.getChildView('comment').removeReplyTask();
                this.getChildView('comment').cleanup();
                this.getChildView('comment').commentEnabled();
                this.trigger('comment:sent');
            });
    }

    onReply(child) {
        this.getChildView('comment').setReplyTo(child.model);
        this.activate(child.model.key, {notShowReplyComments: true});
    }

    onReplyTask(child) {
        this.getChildView('comment').setReplyTask(child.model);
    }

    onCommentSentDraft(comment) {
        CommentCollectionRepository.saveDraft(this.model, comment);
    }

    openComment() {
        this.getChildView('comment').open();
    }

    closeComment() {
        this.getChildView('comment').close();
    }

    addRecord(record) {
        this.getChildView('comment').addRecord(record)
    }

    addRelation(relation) {
        this.getChildView('comment').addRelation(relation);
    }

    addContent(content) {
        this.getChildView('comment').addContent(content);
    }

    addModel(model) {
        this.getChildView('comment').addModel(model);
    }

    autoScrollToFocus() {
        this.getChildView('list').autoScrollToFocus();
    }

    activate(commentKey, options={}) {
        this.getChildView('list').onChangeActivate(commentKey, options);
    }

    smartScrollToKey(commentKey) {
        this.getChildView('list').smartScrollToKey(commentKey);
    }

    showJumpToRecentMessage() {
        this.$('.timeline-jump-to-recent-message').show();
    }

    hideJumpToRecentMessage() {
        this.$('.timeline-jump-to-recent-message').hide();
    }

    jumpToRecentMessage() {
        this.getChildView('list').onChangeActivate(null, {});
        this.getChildView('list').scrollToBottom();
    }

    activateByHashState() {
        const pattern = new RegExp('#/comments/([0-9a-f]+)');
        const commentID = location.hash && location.hash.match(pattern) && location.hash.match(pattern)[1];
        if (!commentID) {
            return;
        }

        const context = this.getOption('context');
        const project = context.getProject();

        const onCommentActivate = this.getOption('onCommentActivate');
        if (onCommentActivate) {
            onCommentActivate();
        }

        const commentKey = new Key(`Project:${project.id}/Comment:${commentID}`);
        const collection = this.getOption('collection');

        collection.fetchPageByItemKey(commentKey)
            .then(() => {
                this.activate(commentKey);

                // レンダリング完了するまで少し待ってからスクロールする
                _.delay(() => {
                    this.smartScrollToKey(commentKey);
                }, 50 /* ms */);
            });
    }
}

module.exports = TimelineView;



// WEBPACK FOOTER //
// ./balus/ui/view/timeline/index.js